<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Struttura - Presidio" header-tag="header"
                    footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label>Struttura<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.codiceStruttura"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceStruttura"
                                text-field="denominazione" :options="strutturaOptions" :disabled="!isEdit"
                                @change="onChangeStruttura"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label>Presidio<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idPresidio"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="id" text-field="denominazione"
                                :options="presidiOptions" :disabled="!isEdit"
                                @change="onChangePresidio"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label>Regime<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.regime"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codice" text-field="descrizione"
                                :options="regimiOptions" :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label>{{ getLabelTraduora("nurity.accettazione.setting") }}</label>
                            <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.settingCodice"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codice" text-field="setting"
                                :options="settingsPresidiOptions" :disabled="!isEdit" @change="onChangeSettingCodice">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label>Livello</label>
                            <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idSettingLivello"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="id" text-field="descrizione"
                                :options="settingLivelliOptions" :disabled="!isEdit"
                                @change="onChangeRsaSettingLivelli"> </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Data Segnalazione</label>
                            <date-picker format="DD/MM/YYYY HH:mm" value-type="timestamp"
                                v-model="jsonData.dataSegnalazione" type="datetime" :disabled="!isEdit"></date-picker>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Data Accettazione</label>
                            <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataAccettazione"
                                type="date" :disabled="!isEdit || jsonData.statoAttuale == null"></date-picker>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data" v-if="jsonData.statoAttuale === 'RICOVERATO'">Data
                                Ricovero / Presa in carico</label>
                            <label class="sa-label-data" v-else>Data Arruolamento</label>
                            <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataRicovero"
                                type="date" :disabled="!isEdit || jsonData.dataRicovero == null"></date-picker>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Data Dimissione</label>
                            <date-picker format="DD/MM/YYYY" value-type="timestamp"
                                v-model="jsonData.dataDimissioneTrasferimento" type="date"
                                :disabled="true"></date-picker>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anagrafica" header-tag="header" footer-tag="footer"
                    title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Tipo Identificativo</label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.tipoIdentificativo"
                                class="mb-2 mr-sm-2 mb-sm-0" :options="tipiIdentificativoOptions" :value="null"
                                value-field="codice" text-field="descrizione" required disabled></b-form-select>
                        </b-col>
                        <b-col v-if="anagraficaRicerca" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Codice Fiscale/STP/ENI*</label>
                            <b-input-group class="mb-3">
                                <b-form-input maxlength="16" class="text-uppercase"
                                    v-model="jsonData.accettazioneAnagrafica.identificativo" @keypress="onKeyPress"
                                    :disabled="!isEdit" :readonly="isCheckIdentificativo"></b-form-input>
                                <b-button size="sm" variant="" :disabled="!isEdit || isCheckIdentificativo"
                                    @click="onSearchAnagraficaClick"><b-icon icon="search"></b-icon></b-button>
                            </b-input-group>
                        </b-col>
                        <b-col v-else cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data"> {{ this.$i18n.t("patients.lblFiscalCode") }}<span
                                    style="color: red">*</span> </label>
                            <b-input-group class="mb-3">
                                <b-form-input maxlength="16" class="text-uppercase"
                                    v-model="jsonData.accettazioneAnagrafica.identificativo"
                                    :disabled="!isEdit || isCheckIdentificativo"></b-form-input>
                                <b-button size="sm" variant="" :disabled="!isEdit || isCheckIdentificativo"
                                    v-b-tooltip.hover title="Check Codice Fiscale"
                                    @click="onClickCodiceFiscale(jsonData.accettazioneAnagrafica.identificativo)"><b-icon
                                        icon="search"></b-icon></b-button>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Cognome<span style="color: red">*</span></label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.cognome"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Nome
                                <span style="color: red">*</span>
                            </label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.nome"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Data di nascita<span style="color: red">*</span></label>
                            <date-picker format="DD/MM/YYYY" value-type="timestamp"
                                v-model="jsonData.accettazioneAnagrafica.dataNascita" type="date"
                                :disabled="!isEdit"></date-picker>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Provincia di nascita<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.provinciaNascita" class="mb-2 mr-sm-2 mb-sm-0"
                                :options="provinceNascitaOptions" :value="null" value-field="sigla"
                                text-field="provincia" @change="onChangeProvinciaNascita" required
                                :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Comune di nascita<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.comuneNascitaCodiceIstat"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat" text-field="comune"
                                :options="comuniNascitaOptions" @change="onChangeComuneNascita" required
                                :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <label class="sa-label-data">Sesso<span style="color: red">*</span></label>
                            <b-form-select v-model="jsonData.accettazioneAnagrafica.sesso" :options="sessoOptions"
                                :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Numero di Telefono</label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.telefono"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">E-Mail</label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.email"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <slot name="anagrafica-info"></slot>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <b-card class="sa-card sa-card-border" header="Residenza" header-tag="header" footer-tag="footer"
                    title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Regione<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.regioneResidenza" class="mb-2 mr-sm-2 mb-sm-0"
                                :value="null" value-field="codiceIstat" text-field="regione"
                                :options="regioniResidenzaOptions" @change="onChangeRegioneResidenza" required
                                :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Provincia<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.provinciaResidenza"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="sigla" text-field="provincia"
                                :options="provinceResidenzaOptions" @change="onChangeProvinciaResidenza" required
                                :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Comune<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat" text-field="comune"
                                :options="comuniResidenzaOptions" @change="onChangeComuneResidenza" required
                                :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">CAP<span style="color: red">*</span></label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.capResidenza"
                                @input="onInputCapResidenza" :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Indirizzo<span style="color: red">*</span></label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.indirizzoResidenza"
                                @input="onInputIndirizzoResidenza" :disabled="!isEdit"></b-form-input>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <b-card class="sa-card sa-card-border" header="Domicilio" header-tag="header" footer-tag="footer"
                    title="">
                    <template #header>
                        <div style="display: flex">
                            <span style="flex: 1">Domicilio</span>
                            <b-form-checkbox v-model="isDomicilioUgualeResidenza" name="check-button" switch
                                :disabled="!isEdit">Coincide
                                con residenza</b-form-checkbox>
                        </div>
                    </template>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Regione<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref" class="mb-2 mr-sm-2 mb-sm-0"
                                v-model="jsonData.accettazioneAnagrafica.regioneDomicilio" :value="null"
                                value-field="codiceIstat" text-field="regione" :options="regioniDomicilioOptions"
                                @change="onInputRegioniDomicilio" required
                                :disabled="!isEdit || isDomicilioUgualeResidenza"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Provincia<span style="color: red">*</span></label>

                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.provinciaDomicilio"
                                class="mb-2 mr-sm-2 mb-sm-0" :options="provinceDomicilioOptions" :value="null"
                                value-field="sigla" text-field="provincia" @change="onInputProvinciaDomicilio" required
                                :disabled="!isEdit || isDomicilioUgualeResidenza"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Comune<span style="color: red">*</span></label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat"
                                class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat" text-field="comune"
                                :options="comuniDomicilioOptions" @change="onInputComuneDomicilio" required
                                :disabled="!isEdit || isDomicilioUgualeResidenza"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">CAP<span style="color: red">*</span></label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.capDomicilio"
                                :disabled="!isEdit || isDomicilioUgualeResidenza"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Indirizzo<span style="color: red">*</span></label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.indirizzoDomicilio"
                                :disabled="!isEdit || isDomicilioUgualeResidenza"></b-form-input>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <b-card class="sa-card sa-card-border" header="ASL di residenza" header-tag="header" footer-tag="footer"
                    title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Codice A.S.L.</label>
                            <b-form-input v-model="jsonData.accettazioniAsl.aslResidenzaCodice"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">A.S.L.</label>
                            <b-form-input v-model="jsonData.accettazioniAsl.aslResidenzaDenominazione"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Ambito</label>
                            <b-form-select v-model="jsonData.accettazioniAsl.aslResidenzaAmbito"
                                :options="ambitiAslResidenzaOptions" text-field="text" value-field="value"
                                :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Distretto</label>
                            <b-form-select v-model="jsonData.accettazioniAsl.aslResidenzaDistretto"
                                :options="distrettiAslResidenzaOptions" value-field="codiceDistretto"
                                text-field="descrizione" :disabled="!isEdit"></b-form-select>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <b-card class="sa-card sa-card-border" header="ASL di domicilio" header-tag="header" footer-tag="footer"
                    title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Codice A.S.L.</label>
                            <b-form-input v-model="jsonData.accettazioniAsl.aslDomicilioCodice"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">A.S.L.</label>
                            <b-form-input v-model="jsonData.accettazioniAsl.aslDomicilioDenominazione"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Ambito</label>
                            <b-form-select v-model="jsonData.accettazioniAsl.aslDomicilioAmbito"
                                :options="ambitiAslDomicilioOptions" text-field="text" value-field="value"
                                :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Distretto</label>
                            <b-form-select v-model="jsonData.accettazioniAsl.aslDomicilioDistretto"
                                :options="distrettiAslDomicilioOptions" value-field="codiceDistretto"
                                text-field="descrizione" :disabled="!isEdit"></b-form-select>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Altre info" header-tag="header" footer-tag="footer"
                    title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Provenienza Richiesta</label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.provenienzaRichiesta"
                                class="mb-2 mr-sm-2 mb-sm-0" :options="provenienzaRichiestaOptions" :value="null"
                                value-field="codice" text-field="descrizione" required :disabled="!isEdit"
                                @change="onChangeProvenienzaRichiesta"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Struttura di Provenienza</label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.strutturaProvenienza"
                                class="mb-2 mr-sm-2 mb-sm-0" :options="strutturaProvenienzaOptions" :value="null"
                                value-field="codice" text-field="descrizione" @change="onChangeStrutturaProvenienza"
                                required :disabled="!isEdit || !isProvienzaRichiestaDisable"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Unità operativa / Reparto</label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.codiceStrutturaProvenienzaReparto"
                                class="mb-2 mr-sm-2 mb-sm-0" :options="strutturaProvenienzaRepartiOptions" :value="null"
                                value-field="codiceReparto" text-field="descrizioneReparto" required
                                :disabled="!isEdit || !isProvienzaRichiestaDisable"
                                @change="onChangeStrutturaProvenienzaReparto"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Medico Inviante</label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.medicoInviante"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Provenienza ospite</label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.provenienzaPaziente"
                                class="mb-2 mr-sm-2 mb-sm-0" :options="provenienzaPazienteOptions" :value="null"
                                value-field="codice" text-field="descrizione" :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Tipologia Ospite</label>
                            <b-form-select id="inline-form-custom-select-pref"
                                v-model="jsonData.accettazioneAnagrafica.tipologiaPaziente" class="mb-2 mr-sm-2 mb-sm-0"
                                :options="tipologiaPazienteOptions" :value="null" value-field="codice"
                                text-field="descrizione" :disabled="!isEdit"></b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">MMG/PLS</label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.medicoCurante"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">MMG/PLS Telefono</label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.medicoCuranteTelefono"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">MMG/PLS E-Mail</label>
                            <b-form-input v-model="jsonData.accettazioneAnagrafica.emailMedicoCurante"
                                :disabled="!isEdit"></b-form-input>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Diagnosi e Note" header-tag="header" footer-tag="footer"
                    title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <b-input-group class="mb-3">
                                <label class="sa-label-data">Diagnosi in Ingresso</label>
                                <b-button variant="" :disabled="!isEdit" @click="onClickSearchIcdix"><b-icon
                                        icon="search">
                                    </b-icon></b-button>
                            </b-input-group>
                            <b-form-textarea v-model="jsonData.diagnosiIngresso" placeholder="" rows="7"
                                :disabled="!isEdit"></b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Note</label>
                            <b-form-textarea v-model="jsonData.accettazioneAnagrafica.note" id="textarea-auto-height"
                                placeholder="" rows="7" style="margin-top: 12px" :disabled="!isEdit"></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <diagnosi-icd-ix-component v-show="false" ref="cmpDiagnosiIcdIx"
            @onModalClose="modalClose"></diagnosi-icd-ix-component>
    </div>
</template>
<script>
import axios from "axios";
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import UtilityMixin from "../../../utility/UtilityMixin";
import DiagnosiIcdIxComponent from "../../../utility/components/DiagnosiIcdIxComponent.vue";
export default {
    props: {
        jsonData: { type: Object, required: true },
        id: { type: [String, Number], default: null },
        isEdit: { type: Boolean, default: true },
    },
    components: {
        DatePicker,
        DiagnosiIcdIxComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResourceRegimi: "/accettazioneregimi",
            pathResourceStrutture: "/strutture",
            pathResourcePresidi: "/strutturepresidi",
            pathResourceProvince: "/province",
            pathResourceComuni: "/comuni/provincia",
            pathResourceRegioni: "/regioni",
            pathResourceComune: "/comuni/istat",
            pathResourceAsl: "/asl/comune",
            pathResourceIdentificativo: "/anagraficaidentificativo",
            pathResourceSettingsPresidi: "/rsasettingspresidi",
            pathResourceTitoliStudio: "/rsatitolistudio",
            pathResourceAmbiti: "/serviziambiticomuni",
            pathResourceDistretti: "/servizidistretticomuni",
            pathResourceTipologiaPaziente: "/accettazioneanagraficatipologiapaziente",
            pathResourceProvenienzaPaziente: "/accettazioneanagraficaprovenienzapaziente",
            pathResourceRsaSettingLivelli: "/rsasettinglivelli",
            pathResourceProvenienzaRichiesta: "/rsaprovenienzarichiesta",
            pathResourceStrutturaProvenienzaReparti: "/rsastruttureprovenienzareparti",
            pathResourceStruttureProvienza: "/rsastruttureprovenienza",
            anagraficaRicerca: false,
            isDomicilioUgualeResidenza: false,
            isCheckIdentificativo: false,
            filtro: { regione: null },
            strutturaOptions: [{ codiceStruttura: null, denominazione: "- Seleziona Struttura -" }],
            presidiOptions: [{ id: null, denominazione: "-Seleziona Presidio-" }],
            regimiOptions: [],
            regioniResidenzaOptions: [],
            regioniDomicilioOptions: [],
            provinceNascitaOptions: [],
            provenienzaPazienteOptions: [{ codice: null, descrizione: "-Seleziona Valore-" }],
            provenienzaRichiestaOptions: [{ codice: null, descrizione: "-Seleziona Valore-" }],
            strutturaProvenienzaOptions: [{ codice: null, descrizione: "-Seleziona Valore-" }],
            strutturaProvenienzaRepartiOptions: [{ codiceReparto: null, descrizioneReparto: "-Seleziona Valore-" }],
            tipologiaPazienteOptions: [{ codice: null, descrizione: "-Seleziona Valore-" }],
            provinceResidenzaOptions: [{ codice: null, provincia: "-Seleziona Provincia-" }],
            provinceDomicilioOptions: [{ codice: null, provincia: "-Seleziona Provincia-" }],
            comuniResidenzaOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            comuniDomicilioOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            comuniNascitaOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            tipiIdentificativoOptions: [{ codice: null, descrizione: "-Seleziona Tipo Identificativo-" }],
            tipoDocumentoOptions: [],
            settingsPresidiOptions: [{ codice: null, setting: "-Seleziona " + this.getLabelTraduora("nurity.accettazione.setting") + "-" }],
            ambitiAslDomicilioOptions: [{ text: "- Seleziona Valore -", value: null }],
            ambitiAslResidenzaOptions: [{ text: "- Seleziona Valore -", value: null }],
            distrettiAslDomicilioOptions: [{ descrizione: "- Seleziona Valore -", codiceDistretto: null }],
            distrettiAslResidenzaOptions: [{ descrizione: "- Seleziona Valore -", codiceDistretto: null }],
            codiceFiscaleValido: false,
            isProvienzaRichiestaDisable: false,
            sessoOptions: [
                { value: null, text: "-Selezionare Sesso-" },
                { value: "M", text: "Maschio" },
                { value: "F", text: "Femmina" },
            ],
            decretoInvaliditaOptions: [
                { value: null, text: "- SI / NO -" },
                { value: "SI", text: "Si" },
                { value: "NO", text: "No" },
            ],
            nonAutonomoOptions: [
                { value: null, text: "- SI / NO -" },
                { value: "SI", text: "Si" },
                { value: "NO", text: "No" },
            ],
            titoloStudioOptions: [],
            settingLivelliOptions: [{ id: null, descrizione: "- Seleziona Valore -" }],
        };
    },
    watch: {
        isDomicilioUgualeResidenza(value) {
            let me = this;
            if (value) {
                me.setDomicilio();
                me.provinceDomicilioOptions = me.provinceResidenzaOptions.slice();
                me.comuniDomicilioOptions = me.comuniResidenzaOptions.slice();
                me.ambitiAslDomicilioOptions = me.ambitiAslResidenzaOptions.slice();
                me.distrettiAslDomicilioOptions = me.distrettiAslResidenzaOptions.slice();
                me.jsonData.accettazioniAsl.aslDomicilioCodice = me.jsonData.accettazioniAsl.aslResidenzaCodice;
                me.jsonData.accettazioniAsl.aslDomicilioDenominazione = me.jsonData.accettazioniAsl.aslResidenzaDenominazione;
                me.jsonData.accettazioniAsl.aslDomicilioAmbito = me.jsonData.accettazioniAsl.aslResidenzaAmbito;
                me.jsonData.accettazioniAsl.aslDomicilioDistretto = me.jsonData.accettazioniAsl.aslResidenzaDistretto;
            }
        },
    },
    mounted() {
        let me = this;
        me.anagraficaRicerca = this.appConfig.anagraficaRicerca;
        me.loadStrutture();
        me.loadRegimi();
        me.loadProvinceNascita();
        me.loadRegioni();
        me.loadIdentificativi();
        me.loadTipoDocumento();
        me.loadTitoliStudio();
        me.loadStruttureProvienza();
        me.loadTipologiaPaziente();
        me.loadProvenienzaPaziente();
        me.loadProvenienzaRichiesta();
        console.log(this.jsonData);

    },
    methods: {
        init() {
            let me = this;
            me.isCheckIdentificativo = true;
            me.setPresidi();
            me.checkDomicilioUgualeResidenza();
            me.loadSettingsPresidi(me.jsonData.idPresidio);
            me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaNascita, "nascita");
            me.loadProvince(me.jsonData.accettazioneAnagrafica.regioneResidenza, "residenza");
            me.loadProvince(me.jsonData.accettazioneAnagrafica.regioneDomicilio, "domicilio");
            me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaResidenza, "residenza");
            me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaDomicilio, "domicilio");
            me.loadAmbitiAsl(me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat, "residenza");
            me.loadAmbitiAsl(me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat, "domicilio");
            me.loadDistrettiAsl(me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat, "residenza");
            me.loadDistrettiAsl(me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat, "domicilio");
            me.loadDataSettingLivelli(me.jsonData.idSetting);
            if (me.jsonData.accettazioneAnagrafica.strutturaProvenienza) {
                me.onChangeStrutturaProvenienza(me.jsonData.accettazioneAnagrafica.strutturaProvenienza);
            }
        },
        checkDomicilioUgualeResidenza() {
            let me = this;
            let anagrafica = me.jsonData.accettazioneAnagrafica;
            if (
                anagrafica.regioneResidenza &&
                anagrafica.regioneResidenza === anagrafica.regioneDomicilio &&
                anagrafica.provinciaResidenza === anagrafica.provinciaDomicilio &&
                anagrafica.comuneResidenzaCodiceIstat === anagrafica.comuneDomicilioCodiceIstat &&
                anagrafica.capResidenza === anagrafica.capDomicilio &&
                anagrafica.indirizzoResidenza === anagrafica.indirizzoDomicilio
            ) {
                me.isDomicilioUgualeResidenza = true;
            }
        },
        setDomicilio() {
            let me = this;
            if (me.isDomicilioUgualeResidenza) {
                me.jsonData.accettazioneAnagrafica.regioneDomicilio = me.jsonData.accettazioneAnagrafica.regioneResidenza;
                me.jsonData.accettazioneAnagrafica.provinciaDomicilio = me.jsonData.accettazioneAnagrafica.provinciaResidenza;
                me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat = me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat;
                me.jsonData.accettazioneAnagrafica.capDomicilio = me.jsonData.accettazioneAnagrafica.capResidenza;
                me.jsonData.accettazioneAnagrafica.indirizzoDomicilio = me.jsonData.accettazioneAnagrafica.indirizzoResidenza;
            }
        },
        loadStrutture() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceStrutture;
            axios
                .get(link)
                .then((response) => {
                    me.strutturaOptions = [];
                    me.rows = response.data.data.recordsNumber;
                    me.strutturaOptions = response.data.data;

                    if (me.strutturaOptions.length === 1) {
                        me.jsonData.codiceStruttura = me.strutturaOptions[0].codiceStruttura;
                        me.loadPresidi(me.strutturaOptions[0].id);
                    } else {
                        me.strutturaOptions.unshift({
                            codiceStruttura: null,
                            denominazione: "-Seleziona Struttura-",
                        });
                    }
                    me.$emit("afterLoadData");
                })
                .catch(() => {
                    me.$emit("afterLoadData");
                });
        },
        loadPresidi(value) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePresidi;
            me.presidiOptions = [];
            me.filtroPresidi = { idStruttura: value };
            axios
                .get(link, { params: me.filtroPresidi })
                .then((response) => {
                    me.presidiOptions = response.data.data.list;
                    if (me.presidiOptions.length === 1) {
                        me.jsonData.idPresidio = me.presidiOptions[0].id;
                        me.loadSettingsPresidi(me.jsonData.idPresidio);
                    } else {
                        me.presidiOptions.unshift({
                            id: null,
                            denominazione: "-Seleziona Presidio-",
                        });
                    }
                    me.$emit("afterLoadData");
                })
                .catch(() => {
                    me.$emit("afterLoadData");
                });
        },
        loadSettingsPresidi(id) {
            let me = this;
            let params = { idPresidio: id };
            this.settingsPresidiOptions = [];
            UtilityMixin.methods.loadDataResources(me.pathResourceSettingsPresidi, params, me.resultResponseSettings, me.resultErrorSettings);
        },
        resultResponseSettings(response) {
            let me = this;
            me.settingsPresidiOptions = response.data.data.list;
            if (me.settingsPresidiOptions.length === 1) {
                me.jsonData.settingCodice = me.settingsPresidiOptions[0].codice;
                me.jsonData.settingDescrizione = me.settingsPresidiOptions[0].setting;
                me.onChangeSettingCodice(me.jsonData.settingCodice);
            }
        },
        resultErrorSettings(response) {
            UtilityMixin.methods.messaggeBoxError(this, response);
        },
        loadRegimi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegimi;
            axios
                .get(link)
                .then((response) => {
                    me.regimiOptions = response.data.data.list;
                    if (me.regimiOptions.length === 1) {
                        me.jsonData.regime = me.regimiOptions[0].codice;
                    }
                    me.regimiOptions.unshift({ codice: null, descrizione: "-Seleziona Regime-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                });
        },
        loadProvinceNascita() {
            let me = this;
            me.provinciaOption = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourceProvince;
            axios
                .get(link)
                .then((response) => {
                    me.provinceNascitaOptions = response.data.data;
                    me.provinceNascitaOptions.unshift({ sigla: null, provincia: "-Seleziona Provincia-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        loadComuni(sigla, destination) {
            let me = this;
            if (!sigla) {
                return;
            }
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuni + "/" + sigla;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((comune) => {
                        switch (destination) {
                            case "nascita":
                                me.comuniNascitaOptions.push(comune);
                                break;
                            case "residenza":
                                me.comuniResidenzaOptions.push(comune);
                                break;
                            case "domicilio":
                                me.comuniDomicilioOptions.push(comune);
                                break;
                        }
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        loadRegioni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegioni;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((regione) => {
                        me.regioniResidenzaOptions.push(regione);
                        me.regioniDomicilioOptions.push(regione);
                    });
                    me.regioniResidenzaOptions.unshift({ codiceIstat: null, regione: "-Seleziona Regione-" });
                    me.regioniDomicilioOptions.unshift({ codiceIstat: null, regione: "-Seleziona Regione-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                });
        },
        loadProvince(regione, destination) {
            let me = this;
            me.filtro = { regione: regione };
            let link = process.env.VUE_APP_PATH_API + me.pathResourceProvince;
            axios.get(link, { params: me.filtro }).then((response) => {
                response.data.data.forEach((provincia) => {
                    switch (destination) {
                        case "residenza":
                            me.provinceResidenzaOptions.push(provincia);
                            break;
                        case "domicilio":
                            me.provinceDomicilioOptions.push(provincia);
                            break;
                    }
                });
                if (me.id !== "-1") {
                    me.setRegioni();
                }
            });
        },
        loadCap(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComune + "/" + codiceIstat;
            if (codiceIstat) {
                axios
                    .get(link)
                    .then((response) => {
                        switch (destination) {
                            case "residenza":
                                me.jsonData.accettazioneAnagrafica.capResidenza = response.data.data.cap;
                                me.setDomicilio();
                                break;
                            case "domicilio":
                                me.jsonData.accettazioneAnagrafica.capDomicilio = response.data.data.cap;
                                break;
                        }
                    })
                    .catch((error) => {
                        console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                    });
            }
        },
        loadAsl(codiceIstat, destination) {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourceAsl;
            let params = { istatComune: codiceIstat };
            if (codiceIstat) {
                axios
                    .get(link, { params: params })
                    .then((response) => {
                        if (response.data.data !== null) {
                            switch (destination) {
                                case "residenza":
                                    me.jsonData.accettazioniAsl.aslResidenzaCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                                    me.jsonData.accettazioniAsl.aslResidenzaDenominazione = response.data.data.denominazione;
                                    break;
                                case "domicilio":
                                    me.jsonData.accettazioniAsl.aslDomicilioCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                                    me.jsonData.accettazioniAsl.aslDomicilioDenominazione = response.data.data.denominazione;
                                    break;
                            }
                        } else {
                            switch (destination) {
                                case "residenza":
                                    me.jsonData.accettazioniAsl.aslResidenzaCodice = null;
                                    me.jsonData.accettazioniAsl.aslResidenzaDenominazione = null;
                                    break;
                                case "domicilio":
                                    me.jsonData.accettazioniAsl.aslDomicilioCodice = null;
                                    me.jsonData.accettazioniAsl.aslDomicilioDenominazione = null;
                                    break;
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);

                        console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                    });
            }
        },
        loadIdentificativi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceIdentificativo;
            me.tipiIdentificativoOptions = [];
            axios
                .get(link)
                .then((response) => {
                    me.tipiIdentificativoOptions = response.data.data;
                    me.tipiIdentificativoOptions.unshift({ codice: null, descrizione: "-Seleziona Tipo Identificativo-" });
                    me.jsonData.accettazioneAnagrafica.tipoIdentificativo = "CF";
                })
                .catch((error) => {
                    console.log("Il servizio dei tipi identificativo ha datao errore: " + error.response.status);
                });
        },
        onChangeStruttura(value) {
            let me = this;
            me.strutturaOptions.forEach((element) => {
                if (element.codiceStruttura === value) {
                    me.loadPresidi(element.id);
                }
            });
        },
        onChangePresidio(value) {
            let me = this;
            me.loadSettingsPresidi(value);
        },
        onChangeSettingCodice(value) {
            let me = this;
            me.settingsPresidiOptions.forEach((element) => {
                if (element.codice === value) {
                    me.jsonData.settingDescrizione = element.setting;
                    me.jsonData.idSetting = element.idRsaSettings;
                    me.loadDataSettingLivelli(element.idRsaSettings);
                }
            });
        },
        onChangeProvinciaNascita(value) {
            let me = this;
            me.comuniNascitaOptions = [];
            me.comuniNascitaOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.loadComuni(value, "nascita");
        },
        onChangeComuneNascita() { },
        onChangeRegioneResidenza(regione) {
            let me = this;
            me.jsonData.accettazioneAnagrafica.provinciaResidenza = null;
            me.provinceResidenzaOptions = [];
            me.provinceResidenzaOptions.unshift({ sigla: null, provincia: "-Seleziona Provincia-" });
            me.jsonData.accettazioniAsl.aslResidenzaCodice = null;
            me.jsonData.accettazioniAsl.aslResidenzaDenominazione = null;
            me.jsonData.accettazioniAsl.aslResidenzaAmbito = null;
            me.jsonData.accettazioniAsl.aslResidenzaDistretto = null;
            me.loadProvince(regione, "residenza");
            me.setDomicilio();
        },
        onChangeProvinciaResidenza(provincia) {
            let me = this;
            me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat = null;
            me.jsonData.accettazioneAnagrafica.capResidenza = null;
            me.comuniResidenzaOptions = [];
            me.comuniResidenzaOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.jsonData.accettazioniAsl.aslResidenzaCodice = null;
            me.jsonData.accettazioniAsl.aslResidenzaDenominazione = null;
            me.jsonData.accettazioniAsl.aslResidenzaAmbito = null;
            me.jsonData.accettazioniAsl.aslResidenzaDistretto = null;
            me.loadComuni(provincia, "residenza");
            me.setDomicilio();
        },
        onChangeComuneResidenza(value) {
            let me = this;
            me.loadCap(value, "residenza");
            me.loadAsl(value, "residenza");
            me.loadDistrettiAsl(value, "residenza");
            me.loadAmbitiAsl(value, "residenza");
            me.setDomicilio();
        },
        onInputRegioniDomicilio(regione) {
            let me = this;
            if (me.isDomicilioUgualeResidenza) {
                return;
            }
            me.provinceDomicilioOptions = [];
            me.provinceDomicilioOptions.unshift({ sigla: null, provincia: "-Seleziona Provincia-" });
            me.jsonData.accettazioniAsl.aslDomicilioCodice = null;
            me.jsonData.accettazioniAsl.aslDomicilioDenominazione = null;
            me.jsonData.accettazioniAsl.aslDomicilioAmbito = null;
            me.jsonData.accettazioniAsl.aslDomicilioDistretto = null;
            me.loadProvince(regione, "domicilio");
        },
        onInputProvinciaDomicilio(provincia) {
            let me = this;
            if (me.isDomicilioUgualeResidenza) {
                return;
            }
            me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat = null;
            me.jsonData.accettazioneAnagrafica.capDomicilio = null;
            me.comuniDomicilioOptions = [];
            me.comuniDomicilioOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.jsonData.accettazioniAsl.aslDomicilioCodice = null;
            me.jsonData.accettazioniAsl.aslDomicilioDenominazione = null;
            me.jsonData.accettazioniAsl.aslDomicilioAmbito = null;
            me.jsonData.accettazioniAsl.aslDomicilioDistretto = null;
            me.loadComuni(provincia, "domicilio");
        },
        onInputComuneDomicilio(value) {
            let me = this;
            if (me.isDomicilioUgualeResidenza) {
                return;
            }
            me.loadCap(value, "domicilio");
            me.loadAsl(value, "domicilio");
            me.loadDistrettiAsl(value, "domicilio");
            me.loadAmbitiAsl(value, "domicilio");
        },
        onInputCapResidenza() {
            let me = this;
            me.setDomicilio();
        },
        onInputIndirizzoResidenza() {
            let me = this;
            me.setDomicilio();
        },
        onKeyPress(e) {
            let me = this;
            if (e.keyCode === 13) {
                me.searchAnagrafica();
            }
        },
        onSearchAnagraficaClick() {
            let me = this;
            me.searchAnagrafica();
        },
        searchAnagrafica() {
            let me = this;
            me.showmolalloading = true;
            if (me.jsonData.accettazioneAnagrafica.identificativo.trim().length === 0) {
                me.showmolalloading = false;
            } else {
                me.jsonData.accettazioneAnagrafica.identificativo = me.jsonData.accettazioneAnagrafica.identificativo.toUpperCase();
                let link = process.env.VUE_APP_PATH_API + "/utility";
                axios
                    .get(link, {
                        params: { codiceFiscale: me.jsonData.accettazioneAnagrafica.identificativo },
                    })
                    .then((response) => {
                        console.log(response.data.data.comuneNascitaCodiceIstat);

                        me.jsonData.accettazioneAnagrafica.nome = response.data.data.nome;
                        me.jsonData.accettazioneAnagrafica.cognome = response.data.data.cognome;
                        me.jsonData.accettazioneAnagrafica.dataNascita = moment(response.data.data.dataNascita, "DD/MM/YYYY").toDate().getTime();
                        me.jsonData.accettazioneAnagrafica.sesso = response.data.data.sesso;
                        me.jsonData.accettazioneAnagrafica.provinciaNascita = response.data.data.provinciaNascita;
                        me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaNascita, "nascita");
                        me.jsonData.accettazioneAnagrafica.regioneResidenza = response.data.data.regioneResidenza;
                        me.loadProvince(me.jsonData.accettazioneAnagrafica.regioneResidenza, "residenza");
                        me.jsonData.accettazioneAnagrafica.comuneNascitaCodiceIstat = response.data.data.comuneNascitaCodiceIstat;
                        me.jsonData.accettazioneAnagrafica.provinciaResidenza = response.data.data.provinciaResidenza;
                        me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaResidenza, "residenza");
                        me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat = response.data.data.codiceIstatComuneResidenza;
                        me.loadCap(response.data.data.codiceIstatComuneResidenza, "residenza");
                        me.loadAsl(response.data.data.codiceIstatComuneResidenza, "residenza");
                        me.setDomicilio();
                        me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaDomicilio, "domicilio");
                        me.jsonData.accettazioneAnagrafica.indirizzoResidenza = response.data.data.indirizzoResidenza;
                        me.jsonData.accettazioneAnagrafica.codiceFiscaleMedicoCurante = response.data.data.codiceFiscaleMedico;
                        me.jsonData.accettazioneAnagrafica.medicoCurante = response.data.data.medico;

                        me.showmolalloading = false;
                    })
                    .catch(() => {
                        me.showmolalloading = false;
                    });
            }
        },
        setRegioni() {
            let me = this;
            me.provinceResidenzaOptions.forEach((element) => {
                if (element.sigla === me.jsonData.accettazioneAnagrafica.provinciaResidenza) {
                    if (me.jsonData.accettazioneAnagrafica.regioneResidenza === null || me.jsonData.accettazioneAnagrafica.regioneResidenza === "") {
                        me.jsonData.accettazioneAnagrafica.regioneResidenza = element.regione;
                    }
                }
            });
            me.provinceDomicilioOptions.forEach((element) => {
                if (element.sigla === me.jsonData.accettazioneAnagrafica.provinciaDomicilio) {
                    if (me.jsonData.accettazioneAnagrafica.regioneDomicilio === null || me.jsonData.accettazioneAnagrafica.regioneDomicilio === "") {
                        me.jsonData.accettazioneAnagrafica.regioneDomicilio = element.regione;
                    }
                }
            });
        },
        setPresidi() {
            let me = this;
            me.strutturaOptions.forEach((element) => {
                if (element.codiceStruttura === me.jsonData.codiceStruttura) {
                    me.loadPresidi(element.id);
                }
            });
        },

        loadTitoliStudio() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTitoliStudio, {}, me.resultResponseTitoliStudio, me.resultErrorTitoliStudio);
        },
        resultResponseTitoliStudio(response) {
            let me = this;
            me.titoloStudioOptions = response.data.data.list;
            me.titoloStudioOptions.unshift({ codice: null, descrizione: "- Seleziona Titolo di Studio -" });
        },
        resultErrorTitoliStudio(error) {
            console.log(error);
        },
        loadStruttureProvienza() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStruttureProvienza, {}, me.resultResponseStruttureProvenienza, me.resultErrorStruttureProvenienza);
        },
        resultResponseStruttureProvenienza(response) {
            let me = this;
            me.strutturaProvenienzaOptions = response.data.data.list;
            me.strutturaProvenienzaOptions.unshift({ codice: null, descrizione: "- Seleziona Valore -" });
        },
        resultErrorStruttureProvenienza(error) {
            console.log(error);
        },
        loadTipologiaPaziente() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTipologiaPaziente, {}, me.resultResponseTipologiaPaziente, me.resultErrorTipologiaPaziente);
        },
        resultResponseTipologiaPaziente(response) {
            let me = this;
            me.tipologiaPazienteOptions = response.data.data.list;
            me.tipologiaPazienteOptions.unshift({ codice: null, descrizione: "- Seleziona Valore -" });
        },
        resultErrorTipologiaPaziente(error) {
            console.log(error);
        },
        loadProvenienzaPaziente() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProvenienzaPaziente, {}, me.resultResponseProvenienzaPaziente, me.resultErrorProvenienzaPaziente);
        },
        resultResponseProvenienzaPaziente(response) {
            let me = this;
            me.provenienzaPazienteOptions = response.data.data.list;
            me.provenienzaPazienteOptions.unshift({ codice: null, descrizione: "- Seleziona Valore -" });
        },
        resultErrorProvenienzaPaziente(error) {
            console.log(error);
        },
        loadTipoDocumento() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceIdentificativo;
            me.tipiIdentificativoOptions = [];
            axios
                .get(link)
                .then((response) => {
                    me.tipoDocumentoOptions = response.data.data;
                    me.tipoDocumentoOptions.unshift({ codice: null, descrizione: "-Seleziona Tipo Documento-" });
                })
                .catch((error) => {
                    console.log("Il servizio identificativi ha datao errore: " + error.response.status);
                });
        },
        onClickCodiceFiscale(value) {
            let me = this;
            if (value) {
                var regexCodiceFiscale = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/;
                if (regexCodiceFiscale.test(value.toUpperCase())) {
                    this.codiceFiscaleValido = true;
                } else {
                    this.codiceFiscaleValido = false;
                }
                const codice = value;
                me.jsonData.accettazioneAnagrafica.identificativo = codice;
                me.checkCodiceFiscale(me.jsonData.accettazioneAnagrafica.identificativo.toUpperCase());
            } else {
                me.$bvToast.toast("Inserire Codice Fiscale", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        checkCodiceFiscale(codiceFiscale) {
            let me = this;
            if (me.codiceFiscaleValido) {
                let path = "/utilityanagrafica/codicefiscale";
                me.loadDataResources(path, { codiceFiscale: codiceFiscale }, me.resultResponseCodiceFiscale, me.resultErrorCodiceFiscale);
            } else {
                me.$bvToast.toast("Codice Fiscale non corretto", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        resultResponseCodiceFiscale(response) {
            let me = this;

            if (response.data.data.nome) {
                me.jsonData.accettazioneAnagrafica.nome = response.data.data.nome;
            }
            if (response.data.data.cognome) {
                me.jsonData.accettazioneAnagrafica.cognome = response.data.data.cognome;
            }

            if (response.data.data.dataNascita) {
                me.jsonData.accettazioneAnagrafica.dataNascita = response.data.data.dataNascita;
            }
            if (response.data.data.sesso) {
                me.jsonData.accettazioneAnagrafica.sesso = response.data.data.sesso;
            }
            if (response.data.data.provinciaNascita) {
                me.jsonData.accettazioneAnagrafica.provinciaNascita = response.data.data.provinciaNascita;
                me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaNascita, "nascita");
            }
            if (response.data.data.regioneResidenza) {
                me.jsonData.accettazioneAnagrafica.regioneResidenza = response.data.data.regioneResidenza;
                me.loadProvince(me.jsonData.accettazioneAnagrafica.regioneResidenza, "residenza");
            }
            if (response.data.data.comuneNascitaCodiceIstat) {
                me.jsonData.accettazioneAnagrafica.comuneNascitaCodiceIstat = response.data.data.comuneNascitaCodiceIstat;
            }
            if (response.data.data.provinciaResidenza) {
                me.jsonData.accettazioneAnagrafica.provinciaResidenza = response.data.data.provinciaResidenza;
                me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaResidenza, "residenza");
            }
            if (response.data.data.comuneResidenzaCodiceIstat) {
                me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat = response.data.data.comuneResidenzaCodiceIstat;
            }
            me.loadCap(response.data.data.codiceIstatComuneResidenza, "residenza");
            me.loadAsl(response.data.data.codiceIstatComuneResidenza, "residenza");
            me.setDomicilio();
            me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaDomicilio, "domicilio");
            if (response.data.data.indirizzoResidenza) {
                me.jsonData.accettazioneAnagrafica.indirizzoResidenza = response.data.data.indirizzoResidenza;
            }
            if (response.data.data.codiceFiscaleMedico) {
                me.jsonData.accettazioneAnagrafica.codiceFiscaleMedicoCurante = response.data.data.codiceFiscaleMedico;
            }
            if (response.data.data.medico) {
                me.jsonData.accettazioneAnagrafica.medicoCurante = response.data.data.medico;
            }
        },
        resultErrorCodiceFiscale(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            me.$bvToast.toast("Errore durante il caricamento: " + messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickSearchIcdix() {
            let me = this;
            me.$refs.cmpDiagnosiIcdIx.onClickBtnRicercaIcdIx();
        },
        modalClose(data) {
            let me = this;
            let diagnosi = data[0];
            me.$set(me.jsonData, "diagnosiIngresso", "(" + diagnosi[0].codiceIcdix + ") " + diagnosi[0].descrizioneIcdix);
        },
        loadDistrettiAsl(codiceIstat, destination) {
            let me = this;
            if (!codiceIstat) {
                return;
            }
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDistretti;
            let params = { comuneCodiceIstat: codiceIstat };
            axios
                .get(link, { params: params })
                .then((response) => {
                    switch (destination) {
                        case "residenza":
                            me.jsonData.accettazioniAsl.aslResidenzaDistretto = null;
                            me.distrettiAslResidenzaOptions = [];
                            me.distrettiAslResidenzaOptions = response.data.data.list;
                            if (response.data.data.list.length === 1) {
                                me.jsonData.accettazioniAsl.aslResidenzaDistretto = response.data.data.list[0].codiceDistretto;
                            }
                            me.distrettiAslResidenzaOptions.unshift({ descrizione: "- Seleziona Valore -", codiceDistretto: null });
                            break;
                        case "domicilio":
                            me.jsonData.accettazioniAsl.aslDomicilioDistretto = null;
                            me.distrettiAslDomicilioOptions = [];
                            me.distrettiAslDomicilioOptions = response.data.data.list;
                            if (response.data.data.list.length === 1) {
                                me.jsonData.accettazioniAsl.aslDomicilioDistretto = response.data.data.list[0].codiceDistretto;
                            }
                            me.distrettiAslDomicilioOptions.unshift({ descrizione: "- Seleziona Valore -", codiceDistretto: null });
                            break;
                    }
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.data);
                });
        },
        loadAmbitiAsl(codiceIstat, destination) {
            let me = this;
            if (!codiceIstat) {
                return;
            }
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAmbiti;
            let params = { comuneCodiceIstat: codiceIstat };
            axios
                .get(link, { params: params })
                .then((response) => {
                    let list = response.data.data.list;
                    switch (destination) {
                        case "residenza":
                            me.jsonData.accettazioniAsl.aslResidenzaAmbito = null;
                            me.ambitiAslResidenzaOptions = list.map((element) => ({ text: element.codiceAmbito, value: element.codiceAmbito }));
                            if (list.length === 1) {
                                me.jsonData.accettazioniAsl.aslResidenzaAmbito = list[0].codiceAmbito;
                            }
                            me.ambitiAslResidenzaOptions.unshift({ text: "- Seleziona Valore -", value: null });
                            break;
                        case "domicilio":
                            me.jsonData.accettazioniAsl.aslDomicilioAmbito = null;
                            me.ambitiAslDomicilioOptions = list.map((element) => ({ text: element.codiceAmbito, value: element.codiceAmbito }));
                            if (list.length === 1) {
                                me.jsonData.accettazioniAsl.aslDomicilioAmbito = list[0].codiceAmbito;
                            }
                            me.ambitiAslDomicilioOptions.unshift({ text: "- Seleziona Valore -", value: null });
                            break;
                    }
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.data);
                });
        },
        loadDataSettingLivelli(idSetting) {
            let me = this;
            if (idSetting) {
                me.loadDataResources(me.pathResourceRsaSettingLivelli, { idSetting: idSetting }, me.resultResponseSettingLivelli, null);
            }
        },
        resultResponseSettingLivelli(response) {
            let me = this;
            me.settingLivelliOptions = [];
            me.settingLivelliOptions = response.data.data.list;
            me.settingLivelliOptions.unshift({ descrizione: "- Seleziona Valore -", id: null });
        },
        onChangeRsaSettingLivelli(value) {
            let me = this;
            me.settingLivelliOptions.forEach((element) => {
                if (element.id === value) {
                    me.jsonData.descrizioneLivello = element.descrizione;
                }
            });
        },
        loadProvenienzaRichiesta() {
            let me = this;
            me.loadDataResources(me.pathResourceProvenienzaRichiesta, {}, me.resultResponseProvenienzaRichiesta, null);
        },
        resultResponseProvenienzaRichiesta(response) {
            let me = this;
            me.provenienzaRichiestaOptions = [];
            me.provenienzaRichiestaOptions = response.data.data.list;
            me.provenienzaRichiestaOptions.unshift({ codice: null, descrizione: "- Seleziona Valore -" });
        },
        onChangeProvenienzaRichiesta(value) {
            let me = this;
            me.isProvienzaRichiestaDisable = value === "ROC" || value === "DIMISSIONI PROTETTE";
        },
        onChangeStrutturaProvenienza(value) {
            let me = this;
            let strutturaProvenienza = me.strutturaProvenienzaOptions.find((element) => element.codice === value);
            if (strutturaProvenienza) {
                me.loadStrutturaProvenienzaReparti(strutturaProvenienza.id);
            }
        },
        loadStrutturaProvenienzaReparti(value) {
            let me = this;
            let filtro = { idRsaStrutturaProvenienza: value };
            me.loadDataResources(me.pathResourceStrutturaProvenienzaReparti, filtro, me.resultResponseStrutturaProvenienzaReparti, null);
        },
        resultResponseStrutturaProvenienzaReparti(response) {
            let me = this;
            me.strutturaProvenienzaRepartiOptions = [];
            me.strutturaProvenienzaRepartiOptions = response.data.data.list;
            me.strutturaProvenienzaRepartiOptions.unshift({ codiceReparto: null, descrizioneReparto: "- Seleziona Valore -" });
        },
        onChangeStrutturaProvenienzaReparto(value) {
            let me = this;
            let reparto = me.strutturaProvenienzaRepartiOptions.find((element) => element.codiceReparto === value);
            if (reparto) {
                me.jsonData.accettazioneAnagrafica.denominazioneStrutturaProvenienzaReparto = reparto.descrizioneReparto;
            }
        },
        getJsonData() {
            return this.jsonData;
        }
    },
};
</script>
<style scoped>
.sa-tab-scrol {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 5px 10px 35px 10px;
}
</style>
